import React, { useEffect, useState, ReactElement } from 'react'

import { RouteProps, useHistory } from 'react-router'
import { Route } from 'react-router-dom'

import { areCredentialsValid, getCredentials } from '../../utils/auth'

interface PrivateRouteProps extends RouteProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.FC<any>
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, ...rest }): ReactElement | null => {
  const history = useHistory()
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const credentials = getCredentials()

    if (credentials === null) {
      history.push('/login')
      return
    }

    areCredentialsValid(credentials.username, credentials.password)
      .then((valid) => {
        if (!valid) {
          history.push('/login')
          return
        }

        setLoading(false)
      })
      .catch(console.error)
  }, [history])

  if (loading) {
    return null
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />
}
export default PrivateRoute
